import { Route, AppId, createPageRoute } from '@lumapps/router';

export const workflowsAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/workflows',
    id: 'workflows-analytics',
    appId: AppId.backOffice,
});
